// extracted by mini-css-extract-plugin
export default {"container":"Loader_container_kWNYQ","loader":"Loader_loader_Q4e6h"};